import { uuidSchema as e } from "../common/index.js";
import { notificationPolicySummarySchema as t } from "./notification.schema.js";
import * as n from "zod";
// src/notifications/notification-management.schema.ts
var r = n.string().max(100).refine((e) => e.isWellFormed() && !e.includes("\0")), i = n.strictObject({ policyId: e }), a = n.strictObject({ teamId: e }), o = n.strictObject({
	query: r.optional(),
	limit: n.union([n.string().regex(/^(?:0*(?:[1-9][0-9]?|100))$/), n.number().int().min(1).max(100)]).pipe(n.coerce.number().int().min(1).max(100)).default(50),
	cursor: n.string().min(1).max(2e3).optional()
}), s = o.extend({ policyTeamId: e }), c = n.strictObject({
	items: n.array(t).max(100),
	nextCursor: n.string().max(2e3).nullable()
}), l = n.strictObject({
	id: e,
	displayName: n.string().max(250),
	role: n.enum(["Agent", "Admin"]),
	isPolicyTeamMember: n.boolean()
}), u = n.strictObject({
	items: n.array(l).max(100),
	nextCursor: n.string().max(2e3).nullable()
}), d = n.enum([
	"INVALID_REQUEST",
	"SESSION_REQUIRED",
	"CAPABILITY_DENIED",
	"NOT_FOUND",
	"VERSION_CONFLICT",
	"IDEMPOTENCY_CONFLICT",
	"REFERENCE_INACTIVE",
	"DEPENDENCY_UNAVAILABLE",
	"PAYLOAD_TOO_LARGE",
	"RATE_LIMITED",
	"STORAGE_UNAVAILABLE",
	"INTERNAL_ERROR"
]), f = n.strictObject({
	path: n.string().max(120),
	reason: n.enum([
		"INVALID_VALUE",
		"OUT_OF_RANGE",
		"DUPLICATE",
		"UNSUPPORTED_FIELD"
	])
}), p = n.strictObject({
	code: d,
	message: n.string().max(200),
	correlationId: e,
	fieldErrors: n.array(f).max(20).optional()
}), m = n.strictObject({ expectedVersion: n.number().int().positive() }), h = n.strictObject({
	id: e,
	deleted: n.literal(!0)
});
export { f as notificationFieldErrorSchema, d as notificationManagementErrorCodeSchema, p as notificationManagementErrorSchema, h as notificationPolicyDeleteResultSchema, m as notificationPolicyDeleteSchema, o as notificationPolicyListQuerySchema, c as notificationPolicyPageSchema, i as notificationPolicyPathSchema, a as notificationPolicyTeamPathSchema, l as notificationRecipientOptionSchema, u as notificationRecipientPageSchema, s as notificationRecipientQuerySchema };

//# sourceMappingURL=notification-management.schema.js.map